import script from "./main-view.vue?vue&type=script&setup=true&lang=js"
export * from "./main-view.vue?vue&type=script&setup=true&lang=js"

import "./main-view.vue?vue&type=style&index=0&id=f7a56b13&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7a56b13"]])

export default __exports__